import EMBEDDED_END_USER_TOKEN_STORAGE_KEY from './embeddedEndUserTokenStorageKey.js';

const readEmbeddedEndUserToken = () => {
  try {
    return sessionStorage.getItem(EMBEDDED_END_USER_TOKEN_STORAGE_KEY);
  } catch {
    /* restricted storage */
    return null;
  }
};

export default readEmbeddedEndUserToken;
